/* template */
<template minapp="mpx" xlang="wxml"><es-card :layout="(['header'])" custom-header="es-content__miniapp_card_header" custom-body="es-content__miniapp_card_body"><div slot="header" class="student-card-title"><div>学生购票说明</div><mpx-view @tap="jumpToComment" class="student-card-more">更多说明<es-icon size="16" name="angle-right" color="#212121" class="es-content__name-info"/></mpx-view></div><div class="student-card-list"><div v-for="(item, index) in (commentList)" class="student-card-item"><div class="student-card-label">{{item.label}}</div><div class="student-card-value" v-if="(item.isArray)"><div v-for="(vItem, index) in (item.value)" class="student-card-value-item">{{vItem}}</div></div><div class="student-card-value" v-else>{{item.value}}</div></div></div></es-card></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m09ab4f50"}'>
.student-card
  &-title
    display flex
    align-items center
    justify-content space-between
  &-list
    margin 12px 0 4px 0
  &-more
    display flex
    align-items center
    font-weight 400
    font-size 12px
  &-item
    display flex
    align-items flex-start
    margin-bottom 16px
  &-label
    width 56px
    font-size 14px
    color #999
    margin-right 40px
  &-value
    flex 1
    font-size 14px
    color #333
    line-height 18px
  &-value-item
    margin-bottom 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m09ab4f50"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./student-card.mpx.js?isComponent&outputPath=components%2Fstudent-card09ab4f50%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./student-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fstudent-card09ab4f50%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m09ab4f50"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/student-card09ab4f50/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-card':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/card/index.mpx?isComponent&outputPath=components%2Findex340a2e8c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
